import {
  IDENTITY_VERIFICATION_MODAL_BRAND_NAME_QUERY_PARAM,
  IDENTITY_VERIFICATION_MODAL_LINK_TO_QUERY_PARAM,
  MODAL_IDENTIFIER_QUERY_PARAM,
  REQUESTED_BRAND_UNLISTED_PRODUCTS_BRAND_TOKEN_QUERY_PARAM,
  RESET_PASSWORD_QUERY_PARAM,
  SAMPLE_PROSPECTING_SAMPLE_REQUEST_COMPLETE_VALUE,
  SAMPLES_REQUEST_MODAL_BRAND_TOKEN_QUERY_PARAM,
  SAMPLES_REQUEST_MODAL_SOURCE_QUERY_PARAM,
  SHOW_MODAL_QUERY_PARAM,
  SIGN_UP_PARAM_KEY,
} from "@faire/deprecated-retailer-visitor-shared/components/App/AppModals/consts";
import { LazyIdentityVerificationModal } from "@faire/deprecated-retailer-visitor-shared/components/App/AppModals/IdentityVerification/index";
import { AppSignIn } from "@faire/deprecated-retailer-visitor-shared/components/AppSignIn/AppSignIn";
import { AppSignUp } from "@faire/deprecated-retailer-visitor-shared/components/AppSignUp/AppSignUp";
import { LazyAchPliUpsellModal } from "@faire/deprecated-retailer-visitor-shared/components/Modals/AchProactiveLimitIncreaseModals/LazyAchPliUpsellModal";
import { LazyAchTermsPreApprovalLandingModal } from "@faire/deprecated-retailer-visitor-shared/components/Modals/AchTermsPreApprovalModals/LazyAchTermsPreApprovalLandingModal";
import { LazyTermsPreApprovalLandingModal } from "@faire/deprecated-retailer-visitor-shared/components/Modals/AchTermsPreApprovalModals/LazyTermsPreApprovalLandingModal";
import { LazyConductorModal } from "@faire/deprecated-retailer-visitor-shared/components/Modals/ConductorModal/LazyConductorModal";
import { LazyConductorFunctionalModal } from "@faire/deprecated-retailer-visitor-shared/components/Modals/ConductorModals/LazyConductorFunctionalModal";
import { LazyFaireDirectCreditFAQModal } from "@faire/deprecated-retailer-visitor-shared/components/Modals/FaireDirectModals/FaireDirectCreditFAQModal/index";
import { LazyFaireDirectFirstOrderIncentiveModal } from "@faire/deprecated-retailer-visitor-shared/components/Modals/FaireDirectModals/FaireDirectFirstOrderIncentiveModal/LazyFaireDirectFirstOrderIncentiveModal";
import { LazyFaireDirectMarketplaceIncentiveModal } from "@faire/deprecated-retailer-visitor-shared/components/Modals/FaireDirectModals/FaireDirectMarketplaceIncentiveModal/LazyFaireDirectMarketplaceIncentiveModal";
import { LazyInsiderEnrollmentModal } from "@faire/deprecated-retailer-visitor-shared/components/Modals/InsiderModals/InsiderEnrollmentModal/LazyInsiderEnrollmentModal";
import { LazyOpeningOrderIncentivesModal } from "@faire/deprecated-retailer-visitor-shared/components/Modals/OpeningOrderIncentivesModal/index";
import { LazyPlaidLinkModal } from "@faire/deprecated-retailer-visitor-shared/components/Modals/payments/PlaidLinkModal/index";
import { LazyProfilePictureUploadModal } from "@faire/deprecated-retailer-visitor-shared/components/Modals/ProfilePictureUploadModal/LazyProfilePictureUploadModal";
import { LazyPromptResetPasswordAfterSignInModal } from "@faire/deprecated-retailer-visitor-shared/components/Modals/PromptResetPasswordAfterSigninModal/LazyPromptResetPasswordAfterSignInModal";
import { LazyRequestUnlistedProductsModal } from "@faire/deprecated-retailer-visitor-shared/components/Modals/RequestUnlistedProductsModal/LazyRequestUnlistedProductsModal";
import { LazyResellerCertificateModal } from "@faire/deprecated-retailer-visitor-shared/components/Modals/ResellerCertificateModal/LazyResellerCertificateModal";
import { LazySamplesRequestModal } from "@faire/deprecated-retailer-visitor-shared/components/Modals/SamplesRequestModal/LazySamplesRequestModal";
import { SamplesRequestStoreProvider } from "@faire/deprecated-retailer-visitor-shared/components/Modals/SamplesRequestModal/SamplesRequestStore";
import { SamplesRequestModalSource } from "@faire/deprecated-retailer-visitor-shared/components/Modals/SamplesRequestModal/types";
import { LazyShopifyPlanUpsellModal } from "@faire/deprecated-retailer-visitor-shared/components/Modals/ShopifyPlanUpsellModal/index";
import { LoggedInAdminWarningModal } from "@faire/deprecated-retailer-visitor-shared/components/Modals/SignUpFailureWarningModal/LoggedInAdminWarningModal";
import { LazyTeamMembersModal } from "@faire/deprecated-retailer-visitor-shared/components/Modals/TeamMembersModal/LazyTeamMembersModal";
import { LazyPastDuePaymentFlow } from "@faire/deprecated-retailer-visitor-shared/components/PastDuePaymentFlow/index";
import { LazyFirstOrderIncentiveModal } from "@faire/deprecated-retailer-visitor-shared/components/PromoModals/FirstOrderIncentiveModal/LazyFirstOrderIncentiveModal";
import { LazyQuickAddModal } from "@faire/deprecated-retailer-visitor-shared/features/ProductQuickAddModal/LazyQuickAddModal";
import { useFaireDirectMarketplaceIncentive } from "@faire/deprecated-retailer-visitor-shared/hooks/FaireDirect/useFaireDirectMarketplaceIncentive/useFaireDirectMarketplaceIncentive";
import { useInsider } from "@faire/deprecated-retailer-visitor-shared/hooks/retailer/useInsider";
import { useIsLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { useRetailerRoutingContext } from "@faire/deprecated-retailer-visitor-shared/RetailerRoutingContextProvider";
import { getIsProduction } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getEnvName";
import { getSettingEnableUnlistedProductsRequests } from "@faire/deprecated-retailer-visitor-shared/settings/getSettingEnableUnlistedProductsRequests";
import { getSettingPreorderIDVSelfSubmit } from "@faire/deprecated-retailer-visitor-shared/settings/getSettingPreorderIDVSelfSubmit";
import { useOpeningOrderIncentives } from "@faire/deprecated-retailer-visitor-shared/stores/domain/useOpeningOrderIncentives";
import { useUserStore } from "@faire/deprecated-retailer-visitor-shared/stores/domain/useUserStore";
import {
  ModalType,
  useAppModal,
} from "@faire/deprecated-retailer-visitor-shared/stores/ui/AppModalStore";
import collectionPage from "@faire/web-api--source/routes/www/product-based-collection/product_based_collection_token";
import { Path } from "@faire/web/common/Path";
import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import { Storage } from "@faire/web/common/Storage";
import { prependLocaleToUrl } from "@faire/web/ui/routing/util";
import React, { Suspense, useCallback } from "react";
import { Redirect, useHistory, useLocation } from "react-router-dom";

import { AppModalEnv } from "../ModalTypes";

/**
 * @param shouldPushBackHistory Sometimes we don't want to goBack to previous page since there's no tag to be remove, without breaking current design, I added this parameter which defaults to true.
 */
export const useCloseAppModals = () => {
  const history = useHistory();
  const currentPath = useCurrentPath();
  return useCallback(
    (shouldPushBackHistory: boolean = true) => {
      const path = currentPath
        .delete([
          "collection",
          "product",
          "brandProductPreview",
          "brandCollectionPreview",
          "net90",
          "updateQuantityOnChange",
          "findByToken",
          "nonBMTier1",
          "nonBMTier2",
          "redirectedFrom",
          "apparelCategorization",
          "marketRsvp",
          "openingOrderIncentives",
          "insiderSignUp",
          "insiderInternationalEnrolment",
          "insiderEnrolment",
          "signIn",
          "signUp",
          "linkPlaid",
          "achProactiveLimitIncrease",
          "achTermsPreApproval",
          "termsPreApproval",
          "termsAssignment",
          SHOW_MODAL_QUERY_PARAM,
          IDENTITY_VERIFICATION_MODAL_BRAND_NAME_QUERY_PARAM,
          SAMPLES_REQUEST_MODAL_BRAND_TOKEN_QUERY_PARAM,
          SAMPLES_REQUEST_MODAL_SOURCE_QUERY_PARAM,
          REQUESTED_BRAND_UNLISTED_PRODUCTS_BRAND_TOKEN_QUERY_PARAM,
          MODAL_IDENTIFIER_QUERY_PARAM,
          RESET_PASSWORD_QUERY_PARAM,
        ])
        .toString();

      if (shouldPushBackHistory) {
        if (history.length > 1) {
          history.goBack();
        } else {
          history.replace(path);
        }
      } else {
        history.push(path);
      }
      try {
        Storage.local.removeItem("PRODUCT_MODAL_ADD_TO_BAG_TRACKING_PATH");
      } catch (_) {
        // silence is golden
      }
    },
    [history, currentPath]
  );
};

// eslint-disable-next-line complexity
export const AppModals: React.FC<{ appModalEnv: AppModalEnv }> = ({
  appModalEnv,
}) => {
  const { showingModalType } = useAppModal();
  const closeAppModals = useCloseAppModals();

  switch (showingModalType) {
    case ModalType.SIGN_IN_FROM_EMAIL:
    case ModalType.SIGN_IN:
      return <SignInModal appModalEnv={appModalEnv} />;
    case ModalType.SIGN_UP:
      return <SignUpModal appModalEnv={appModalEnv} />;
    case ModalType.RESET_PASSWORD_MODAL:
      return <ResetPasswordModal onClose={() => closeAppModals(false)} />;
    case ModalType.PRODUCT:
      return <QuickAddModal />;
    case ModalType.COLLECTION:
      return <CollectionModal />;
    case ModalType.PAYMENT_OPTIONS:
      return <PastDuePaymentFlow />;
    case ModalType.OPENING_ORDER_INCENTIVES_MODAL:
      return <OpeningOrderIncentivesModal />;
    case ModalType.INSIDER_SIGN_UP:
    case ModalType.INSIDER_INTERNATIONAL_ENROLMENT:
    case ModalType.INSIDER_ENROLMENT:
      return <InsiderEnrolmentModal />;
    case ModalType.LINK_PLAID_MODAL:
      return <PlaidLinkModal />;
    case ModalType.IDENTITY_VERIFICATION:
      return <IdentityVerificationModal />;
    case ModalType.FIRST_ORDER_INCENTIVE_MODAL:
      return (
        <Suspense fallback={null}>
          <LazyFirstOrderIncentiveModal
            onCloseModal={() => closeAppModals(false)}
          />
        </Suspense>
      );
    case ModalType.FAIRE_DIRECT_FOI:
      return (
        <Suspense fallback={null}>
          <LazyFaireDirectFirstOrderIncentiveModal />
        </Suspense>
      );
    case ModalType.FAIRE_DIRECT_MARKETPLACE_INCENTIVE_MODAL:
      return <FaireDirectMarketplaceIncentiveAppModal />;
    case ModalType.FAIRE_DIRECT_CREDIT_FAQ:
      return (
        <Suspense fallback={null}>
          <LazyFaireDirectCreditFAQModal />
        </Suspense>
      );
    case ModalType.SHOPIFY_PLAN_UPSELL:
      return (
        <Suspense fallback={null}>
          <LazyShopifyPlanUpsellModal onClose={closeAppModals} />
        </Suspense>
      );
    case ModalType.ACH_PROACTIVE_LIMIT_INCREASE_UPSELL:
      return <AchPliUpsellModal onClose={() => closeAppModals(false)} />;
    case ModalType.ACH_TERMS_PRE_APPROVAL_MODAL:
      return <AchTermsPreApprovalModal onClose={() => closeAppModals(false)} />;
    case ModalType.TERMS_PRE_APPROVAL_MODAL:
      return <TermsPreApprovalModal onClose={() => closeAppModals(false)} />;
    case ModalType.SAMPLES_REQUEST_MODAL:
      return <SamplesRequestModal onClose={() => closeAppModals(false)} />;
    case ModalType.CONDUCTOR_FUNCTIONAL_MODAL:
      return (
        <Suspense fallback={null}>
          <LazyConductorFunctionalModal onClose={() => closeAppModals(false)} />
        </Suspense>
      );
    case ModalType.TEAM_MEMBERS_MODAL:
      return (
        <Suspense fallback={null}>
          <LazyTeamMembersModal onClose={() => closeAppModals(false)} />
        </Suspense>
      );
    case ModalType.PROFILE_PICTURE_UPLOAD_MODAL:
      return (
        <Suspense fallback={null}>
          <LazyProfilePictureUploadModal
            onClose={() => closeAppModals(false)}
          />
        </Suspense>
      );
    // for Conductor-driven modals
    case ModalType.CONDUCTOR_MODAL:
      return (
        <Suspense fallback={null}>
          <LazyConductorModal onClose={() => closeAppModals()} />
        </Suspense>
      );
    case ModalType.RESELLER_CERTIFICATE_MODAL:
      return (
        <Suspense fallback={null}>
          <LazyResellerCertificateModal onClose={() => closeAppModals(false)} />
        </Suspense>
      );
    case ModalType.REQUEST_UNLISTED_PRODUCTS_MODAL:
      return (
        <RequestUnlistedProductsModal
          onClose={() => {
            closeAppModals(false);
          }}
        />
      );
    default:
      return null;
  }
};

const OpeningOrderIncentivesModal: React.FC = () => {
  const { openingOrderIncentivesProps } = useOpeningOrderIncentives();
  if (!openingOrderIncentivesProps) {
    return null;
  }
  return (
    <Suspense fallback={null}>
      <LazyOpeningOrderIncentivesModal {...openingOrderIncentivesProps} />
    </Suspense>
  );
};

const InsiderEnrolmentModal: React.FC = () => {
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const { shouldShowInsider } = useInsider();
  const closeAppModals = useCloseAppModals();

  if (isLoggedInRetailer && shouldShowInsider) {
    return (
      <Suspense fallback={null}>
        <LazyInsiderEnrollmentModal onClose={() => closeAppModals(false)} />
      </Suspense>
    );
  }

  return null;
};

const SignUpModal: React.FC<{ appModalEnv: AppModalEnv }> = ({
  appModalEnv,
}) => {
  const { isEmployee } = useUserStore();
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const closeAppModals = useCloseAppModals();
  const currentPath = useCurrentPath();
  const routingContext = useRetailerRoutingContext();
  const isSSR = useIsSSR();

  if (isEmployee && !getIsProduction()) {
    return <LoggedInAdminWarningModal onClose={closeAppModals} signup={true} />;
  }

  if (isLoggedInRetailer) {
    const newPath = prependLocaleToUrl(
      currentPath.delete("signUp").toString(),
      routingContext
    );
    return <Redirect to={newPath} />;
  }

  // For prospecting retailers, if they'ved requested a sample already,
  // redirect them here without the app signup modal
  if (
    currentPath.searchParams.get(SIGN_UP_PARAM_KEY) ===
    SAMPLE_PROSPECTING_SAMPLE_REQUEST_COMPLETE_VALUE
  ) {
    return null;
  }

  if (isSSR) {
    return null;
  }

  return <AppSignUp appModalEnv={appModalEnv} />;
};

const SignInModal: React.FC<{ appModalEnv: AppModalEnv }> = ({
  appModalEnv,
}) => {
  const { isEmployee } = useUserStore();
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const closeAppModals = useCloseAppModals();
  const currentPath = useCurrentPath();
  const routingContext = useRetailerRoutingContext();

  if (isEmployee && !getIsProduction()) {
    return (
      <LoggedInAdminWarningModal onClose={closeAppModals} signup={false} />
    );
  }

  if (isLoggedInRetailer) {
    const newPath = prependLocaleToUrl(
      currentPath.delete("signIn").toString(),
      routingContext
    );
    return <Redirect to={newPath} />;
  }

  return <AppSignIn appModalEnv={appModalEnv} />;
};

const PastDuePaymentFlow: React.FC = () => {
  const isLoggedInRetailer = useIsLoggedInRetailer();

  if (!isLoggedInRetailer) {
    return null;
  }

  return <LazyPastDuePaymentFlow />;
};

const IdentityVerificationModal: React.FC = () => {
  const currentPath = useCurrentPath();
  const query = currentPath.searchParams;
  const closeAppModals = useCloseAppModals();

  if (!getSettingPreorderIDVSelfSubmit()) {
    const newPath = currentPath.delete([SHOW_MODAL_QUERY_PARAM]).toString();
    return <Redirect to={newPath} />;
  }

  const linkTo =
    query.get(IDENTITY_VERIFICATION_MODAL_LINK_TO_QUERY_PARAM) ?? undefined;
  const brandName =
    query.get(IDENTITY_VERIFICATION_MODAL_BRAND_NAME_QUERY_PARAM) ?? undefined;
  return (
    <Suspense fallback={null}>
      <LazyIdentityVerificationModal
        linkTo={linkTo}
        brandName={brandName}
        onClose={closeAppModals}
      />
    </Suspense>
  );
};

const PlaidLinkModal: React.FC = () => {
  const isLoggedInRetailer = useIsLoggedInRetailer();

  if (!isLoggedInRetailer) {
    return null;
  }

  return <LazyPlaidLinkModal />;
};

const AchPliUpsellModal: React.FC<{
  onClose: () => void;
}> = ({ onClose }) => {
  const isLoggedInRetailer = useIsLoggedInRetailer();

  if (!isLoggedInRetailer) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <LazyAchPliUpsellModal onClose={onClose} />
    </Suspense>
  );
};

const AchTermsPreApprovalModal: React.FC<{
  onClose: () => void;
}> = ({ onClose }) => {
  const isLoggedInRetailer = useIsLoggedInRetailer();

  if (!isLoggedInRetailer) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <LazyAchTermsPreApprovalLandingModal onClose={onClose} />
    </Suspense>
  );
};

const TermsPreApprovalModal: React.FC<{
  onClose: () => void;
}> = ({ onClose }) => {
  const isLoggedInRetailer = useIsLoggedInRetailer();

  if (!isLoggedInRetailer) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <LazyTermsPreApprovalLandingModal onClose={onClose} />
    </Suspense>
  );
};

const QuickAddModal: React.FC = () => {
  const currentPath = useCurrentPath();
  const query = currentPath.searchParams;
  const product = query.get("product");
  const closeAppModals = useCloseAppModals();

  return (
    <Suspense fallback={null}>
      <LazyQuickAddModal
        productToken={product ?? ""}
        onClose={closeAppModals}
      />
    </Suspense>
  );
};

const CollectionModal: React.FC = () => {
  const currentPath = useCurrentPath();
  const query = currentPath.searchParams;
  const collection = query.get("collection");

  return <Redirect to={collectionPage(collection ?? "")} />;
};

const useCurrentPath = (): Path => {
  const location = useLocation();
  return React.useMemo(() => new Path(location), [location]);
};

const SamplesRequestModal: React.FC<{
  onClose: () => void;
}> = ({ onClose }) => {
  const currentPath = useCurrentPath();
  const query = currentPath.searchParams;
  const source = (query.get(SAMPLES_REQUEST_MODAL_SOURCE_QUERY_PARAM) ??
    "HOME") as SamplesRequestModalSource;
  const brandToken = query.get(SAMPLES_REQUEST_MODAL_BRAND_TOKEN_QUERY_PARAM);

  if (brandToken === undefined || brandToken === null) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <SamplesRequestStoreProvider>
        <LazySamplesRequestModal
          onClose={onClose}
          brandToken={brandToken}
          source={source}
        />
      </SamplesRequestStoreProvider>
    </Suspense>
  );
};

const RequestUnlistedProductsModal: React.FC<{
  onClose: () => void;
}> = ({ onClose }) => {
  const currentPath = useCurrentPath();
  const query = currentPath.searchParams;
  const brandToken = query.get(
    REQUESTED_BRAND_UNLISTED_PRODUCTS_BRAND_TOKEN_QUERY_PARAM
  );
  if (!getSettingEnableUnlistedProductsRequests() || !brandToken) {
    return null;
  }
  return (
    <Suspense fallback={null}>
      <LazyRequestUnlistedProductsModal
        onClose={onClose}
        brandToken={brandToken}
      />
    </Suspense>
  );
};

const FaireDirectMarketplaceIncentiveAppModal: React.FC = () => {
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const { hasIncentive } = useFaireDirectMarketplaceIncentive();

  if (!isLoggedInRetailer || !hasIncentive) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <LazyFaireDirectMarketplaceIncentiveModal />
    </Suspense>
  );
};

/** This modal will trigger after user use magic link / code to log in after input wrong password 3 times*/
const ResetPasswordModal: React.FC<{
  onClose: () => void;
}> = ({ onClose }) => {
  return (
    <Suspense fallback={null}>
      <LazyPromptResetPasswordAfterSignInModal onClose={onClose} />
    </Suspense>
  );
};
